import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0004 2.5C4.16743 2.5 2.5 4.16667 2.5 10C2.5 11.527 2.61866 12.7685 2.89733 13.7693C3.68321 16.5917 5.74168 17.5 10.0004 17.5C11.5252 17.5 12.768 17.3836 13.7712 17.1045C15.3512 16.665 16.3371 15.822 16.8953 14.3953C17.3235 13.3009 17.5 11.8629 17.5 10",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4889 5.42758L15.128 2.78853C15.6592 2.25726 16.4917 2.17483 17.1168 2.5916C17.2322 2.66855 17.3313 2.7676 17.4082 2.88303C17.825 3.50818 17.7426 4.34059 17.2113 4.87187L14.5723 7.51091C14.3072 7.77596 13.973 7.9612 13.6078 8.04548L11.4583 8.5415L11.9544 6.39208C12.0386 6.02683 12.2239 5.69263 12.4889 5.42758Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
